import styled from '@emotion/styled';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Tag } from '@shared/components/core/text/ContentTypography';
import { TextSize400, TextSize90 } from '../text/Typography';

/**
 * A MUI Dialog whose paper surface is themed to the app's own background/border tokens. Use this for
 * dialogs that render their own actions (so `ContentDialog`'s fixed footer isn't wanted) — it keeps
 * the surface consistent with the rest of the app instead of falling back to MUI's default paper.
 */
export const ThemedDialog = styled(Dialog)`
    & .MuiPaper-root {
        border: 1px solid ${(props) => props.theme.color.border};
        background: ${(props) => props.theme.color.background};
    }
`;

export const DisplayDialogTitle = styled(DialogTitle)`
    flex: 0 1 auto;
    padding: 0;
    margin: 0;
    align-self: center;
    font-weight: 900;
    color: ${(props) => props.theme.color.text};
    word-break: break-word;
    ${TextSize400}
`;

export const DialogTitleWrap = styled('div')`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 1.5rem 1.5rem 0 1.5rem;
    gap: 0.5rem;
`;

export const StyledDialogContent = styled(DialogContent)`
    padding: 0.25rem 1.5rem 1rem 1.5rem;
`;

export const DialogChildContentWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 1rem;
`;

export const StyledDialogContentText = styled(DialogContentText)`
    padding: 0.25rem 1.5rem 1.5rem 1.5rem;
`;

export const StyledDialogTag = styled(Tag)`
    word-break: keep-all;
    ${TextSize90}
`;
export const StyledDialogActions = styled(DialogActions)`
    padding: 0 1.5rem 1.5rem 1.5rem;
    align-items: center;
`;
